/**
 * Trạng thái giấy đề nghị, Lệnh nhập kho FPT
 */
export default {
  Completed: 1, // Hoàn thành
  Issued: 2, // Đã hạch toán
};
